// Client-synthesized plan_gate for the "locked country" upsell — used when a
// user clicks a country their plan does not cover (no server round-trip). Its
// shape matches the backend all_gcc_countries gate so PlanLimitDialog renders
// identically to a server refusal. Country truth still comes from the server
// (useEntitlements); this only builds the message when the user taps a locked chip.
const COUNTRY_NAMES = {
  en: { SA: 'Saudi Arabia', AE: 'United Arab Emirates', QA: 'Qatar', BH: 'Bahrain', KW: 'Kuwait', OM: 'Oman' },
  ar: { SA: 'السعودية', AE: 'الإمارات', QA: 'قطر', BH: 'البحرين', KW: 'الكويت', OM: 'عمان' },
};

export function buildCountryGate(countryCode, planId, upgradeUrl, language = 'en') {
  const name = (COUNTRY_NAMES[language === 'ar' ? 'ar' : 'en'][countryCode]) || countryCode;
  const message = language === 'ar'
    ? `${name} غير مشمولة في خطتك. قم بالترقية إلى ستاندرد لمتابعة جميع أسواق دول مجلس التعاون الست.`
    : `${name} is not included in your plan. Upgrade to Standard to follow all six GCC markets.`;
  return {
    gate: {
      feature: 'all_gcc_countries',
      current_plan: planId || 'free',
      required_plan: 'standard',
      upgrade_url: upgradeUrl || '/dashboard/settings?tab=plans',
      can_upgrade: true,
    },
    message,
  };
}

export default buildCountryGate;
